import React from 'react'

import { printDollarsFromCents } from 'shared/utils/dollar-print'
import { convertCentsToDollars } from 'shared/utils/ui'

export const formatAmountForInput = (cents?: number | null) =>
  cents !== null && cents !== undefined
    ? convertCentsToDollars(cents).toFixed(2)
    : null

export const formatAmountForCaption = (cents?: number | null) =>
  cents !== null && cents !== undefined ? printDollarsFromCents(cents) : null

export const FieldCaption = ({ children }: { children: React.ReactNode }) => (
  <div style={{ fontSize: 11, color: '#787395', marginTop: 4 }}>{children}</div>
)
